import React from "react";
import { Switch , Button} from "antd";
import { CheckSquareOutlined, CloseOutlined } from "@ant-design/icons";

const columns = [
  {
    title: "SAP SKU",
    dataIndex: "sapSku",
    sorter: (a, b) => a.sapSku.localeCompare(b.sapSku),
     width: 120,
    ellipsis: true, 
    render: (_, record) => <Button type="link"></Button>,
    fixed: 'left',
  },
  {
    title: "SAP Name",
    dataIndex: "sapName",
    sorter: (a, b) => a.sapName.localeCompare(b.sapName),
     width: 200,
     fixed: 'left',
    
  },
  {
    title: "SAP Cust #",
    dataIndex: "sapCustomerNumber",       
    sorter: (a, b) => a.sapCustomerNumber.localeCompare(b.sapCustomerNumber),
     width: 120,
    ellipsis: true, 
  },
  {
    title: "SAP Price",
    dataIndex: "sapPrice",
    sorter: (a, b) => parseFloat(a.sapPrice.slice(1)) - parseFloat(b.sapPrice.slice(1)),
     width: 110,
    ellipsis: true, 
  },
  {
    title: "SAP MSRP",
    dataIndex: "sapMsrp",
    sorter: (a, b) => parseFloat(a.sapMsrp.slice(1)) - parseFloat(b.sapMsrp.slice(1)),
     width: 120,
    ellipsis: true, 
    onCell: (record) => ({
      style: {
        backgroundColor: parseFloat(record.sapMsrp.replace(/[^0-9.]/g, "")) === 0 ? "rgba(255, 0, 0, 0.1)" : "transparent",
      },
    }),
  },
  {
    title: "Available Stock",
    dataIndex: "availableStock",
    sorter: (a, b) => a.availableStock - b.availableStock,
     width: 150,
    ellipsis: true, 
    onCell: (record) => ({
      style: {
        backgroundColor: record.availableStock < 5 ? "rgba(255, 0, 0, 0.1)" : "transparent",
      },
    }),
  },
  {
    title: "Reserved Stock",
    dataIndex: "reservedStock",
    sorter: (a, b) => a.reservedStock - b.reservedStock,
     width: 150,
    ellipsis: true, 
    onCell: (record) => ({
      style: {
        backgroundColor: record.reservedStock < 5 ? "rgba(255, 0, 0, 0.1)" : "transparent",
      },
    }),
  },
  {
    title: "BC SKU",
    dataIndex: "bcSku",
    sorter: (a, b) => a.bcSku.localeCompare(b.bcSku),
     width: 100,
    ellipsis: true, 
  },
  {
    title: "Type",
    dataIndex: "type",        
    sorter: (a, b) => a.type.localeCompare(b.type),
     width: 100,
    ellipsis: true, 
  },
  {
    title: "Active on Store",
    dataIndex: "active",
    render: (_, record) => <Switch checked={record.active} />,
    sorter: (a, b) => (a.active === b.active ? 0 : a.active ? 1 : -1),  
     width: 150,
    ellipsis: true,     
  },
  {
    title: "Store",
    dataIndex: "store",     
    sorter: (a, b) => a.store.localeCompare(b.store),
     width: 90,
    ellipsis: true, 
  },
  {
    title: "BC Inventory",
    dataIndex: "bcInventory",
    sorter: (a, b) => a.bcInventory - b.bcInventory,
     width: 130,
    ellipsis: true, 
  },
  {
    title: "Subscription",
    dataIndex: "subscription",      
    sorter: (a, b) => a.subscription.localeCompare(b.subscription),
     width: 130,
    ellipsis: true, 
  },
  {
    title: "Enrichment",
    dataIndex: "enrichment",
    render: (text) =>
      text!=="" ? (
        text ? (
        <CheckSquareOutlined style={{ color: "green" }} />
      ) : (
        <CloseOutlined style={{ color: "red" }} />
      )):(<span>NA </span>),
    sorter: (a, b) => (a.enrichment === b.enrichment ? 0 : a.enrichment ? 1 : -1), 
     width: 130,
    ellipsis: true,   
  },
  {
    title: "Last Updated",
    dataIndex: "lastUpdated",
    sorter: (a, b) => {
      function parseDMY(dateStr) {
        if (!dateStr) return 0;
        const [datePart, timePart] = dateStr.split(', ');
        if (!datePart || !timePart) return 0;
        const [day, month, year] = datePart.split('/').map(Number);
        const [hour, minute, second] = timePart.split(':').map(Number);
        return new Date(year, month - 1, day, hour, minute, second).getTime();
      }
      return parseDMY(a.lastUpdated) - parseDMY(b.lastUpdated);
    },
     width: 200,
    ellipsis: true, 
  },
  // {
  //   title: "Action",
  //   dataIndex: "action",
  //   render: (_, record) => <Button type="link">{record.action}</Button>,
  // },
];

export default columns;
